import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { Utils } from "../common/utils";

@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  constructor(private router: Router, private utils: Utils) { }
  ACCESS_LINKS = {
    "": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.superadmin,
      Utils.USER_TYPE.front_desk,
      Utils.USER_TYPE.patient,
    ],
    docdashboard: [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    addashboard: [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    dashboard: [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    phydash: [Utils.USER_TYPE.physician],
    "patient-list": [Utils.USER_TYPE.physician],
    "phydash/:pid": [Utils.USER_TYPE.physician],
    contact: [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    help: [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    message: [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    adhocappt: [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    "adhocappt/existing": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    "adhocappt/newpat": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    frontdeskappointments: [
      Utils.USER_TYPE.front_desk,
    ],
    appointments: [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    "appointments/Checkout": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "appointments/Checkin": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "appointments/schedule": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "appointments/Checkout/patient/:cid": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "appointments/Checkin/Detail/:cid": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "appointments/Checkin/edit/:aid": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "appointments/request": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "appointment/consultation": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    "physician/consultation": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    myfiles: [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    profile: [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "profile/search/:type": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "profile/fdesk-profile": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    "profile/user-profile/:id": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "profile/delete-fdesk-profile": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    "profile/patient": [
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk
    ],
    "profile/edit-patient": [
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk
    ],
    "profile/patient-profile/:id": [
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "profile/delete-patient": [
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.front_desk,
    ],
    "pathealthupdate": [
      Utils.USER_TYPE.admin,
      Utils.USER_TYPE.physician,
    ],
    "superadmin/physicians": [
      Utils.USER_TYPE.superadmin,
    ],
    "superadmin/patients": [
      Utils.USER_TYPE.superadmin,
    ],
    "superadmin/appointments": [
      Utils.USER_TYPE.superadmin
    ],
    "superadmin/coupon-generate": [
      Utils.USER_TYPE.superadmin,
    ],
    "superadmin/coupon-search": [
      Utils.USER_TYPE.superadmin,
    ],
    "superadmin/medicine-create": [
      Utils.USER_TYPE.superadmin,
    ],
    "superadmin/medicine-search": [
      Utils.USER_TYPE.superadmin,
    ],
    "prescription/template-edit": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    "prescription/template-create": [
      Utils.USER_TYPE.physician,
      Utils.USER_TYPE.admin,
    ],
    "superadmin/pat-detail": [
      Utils.USER_TYPE.superadmin,
    ],
    "superadmin/specialities": [
      Utils.USER_TYPE.superadmin,
    ],
    "superadmin/phy-detail": [
      Utils.USER_TYPE.superadmin,
    ],
    "superadmin/default-payout": [
      Utils.USER_TYPE.superadmin,
    ],
    "superadmin/physician-payout": [
      Utils.USER_TYPE.superadmin
    ],
    "superadmin/illness-list": [
      Utils.USER_TYPE.superadmin
    ],
    "superadmin/labtest": [
      Utils.USER_TYPE.superadmin
    ],

    admindashboard: [Utils.USER_TYPE.admin],
    superadmindashboard: [Utils.USER_TYPE.superadmin],
    "profile/doctor": [Utils.USER_TYPE.admin],
    "profile/physicians-profile/:id": [Utils.USER_TYPE.admin, Utils.USER_TYPE.physician],
    "profile/delete-doctor": [Utils.USER_TYPE.admin],
    "expand-register": [Utils.USER_TYPE.admin],

    "organisation-edit/:id": [Utils.USER_TYPE.admin],

    Services: [Utils.USER_TYPE.admin, Utils.USER_TYPE.front_desk],
    "org-srv": [Utils.USER_TYPE.admin, Utils.USER_TYPE.front_desk],
    "servicelist": [Utils.USER_TYPE.admin, Utils.USER_TYPE.front_desk],
    "patient/members": [Utils.USER_TYPE.patient],
    "patient/add": [Utils.USER_TYPE.patient],
    "patient/appointments": [Utils.USER_TYPE.patient],
    "patient/account": [Utils.USER_TYPE.patient],
  };

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    let roleId = JSON.parse(localStorage.getItem("LogUsrTyp"));
    let allowedRoles = this.ACCESS_LINKS[route.routeConfig.path];
    if (allowedRoles && this.utils.checkRoutesAccess(roleId, allowedRoles)) {
      return of(true);
    } else {
      this.router.navigate(["/dashboard"]);
      return of(false);
    }
  }
}